module.exports = __webpack_public_path__ + "static/media/cuestionarios.ab1a8b33.svg";